<div id="two-col-menu" class="text-mute" data-simplebar>
    <div class="twocolumn-menu-item d-block">
        <ng-container class="cursor">
            <div>
                <div class="d-flex align-items-center justify-content-center flex-column w-100 text-center">
                    <div class="avatar-lg overflow-hidden">
                        <img *ngIf="patient.patient.thumbnailUrl" [src]="safe(patient.patient.thumbnailUrl)" class="rounded-circle avatar-lg" [alt]="patient.patient.fullName">
                        <span *ngIf="!patient.patient.thumbnailUrl" class="avatar-title rounded-circle bg-primary font-24 text-white" [textContent]="patient.patient.fullName | initials"></span>
                    </div>
                    <div class="w-100 mt-1 bg-primary">
                        <span (click)="onViewPatientProfile(commonid)" class="mb-1 font-16 onHoverUnderline"><a href="javascript:;" class="text-white" [textContent]="patient.patient.patientName"></a></span>
                        <p class="mb-0 text-white">
                            <span [textContent]="patient.patient.umrNo || '--'"></span>
                        </p>
                    </div>
                </div>

                <div class="encounter-profile-list">
                    <ul style="line-height:30px;">
                        <li>
                            <i class="mdi mdi-gender-male-female  text-primary mr-1"></i><span class="font-weight-bolder">Gender :</span>
                            <span class="font-13 mt-1x" [textContent]="'(' + patient.patient.gender+ ') '"></span>
                        </li>
                        <li>
                            <i class="mdi mdi-human-male-height text-primary mr-1"></i><span class="font-weight-bolder">Age :</span>
                            <span class="font-13 mt-1x" [textContent]="patient.patient.dateOfBirth != null ? (patient.patient.dateOfBirth | age:'days') : patient.patient.age == null? 'null' : patient.patient.age + 'yrs'"></span>
                        </li>
                        <li *ngIf="patient.patient.mobile">
                            <i class="mdi mdi-phone-classic text-primary"></i><sup class="text-primary">1</sup><span [textContent]="'(+'+ patient.patient.countryCode +') '+ patient.patient.mobile"></span>
                        </li>
                        <li *ngIf="!patient.patient.mobile">
                            <i class="mdi mdi-phone-classic text-primary mr-1"><sup class="text-primary">1</sup></i><span [textContent]="'No mobile recorded'"></span>
                        </li>
                        <li *ngIf="relativeMobile">
                            <i class="mdi mdi-phone-classic text-primary white-space-nowrap mr-1"><sup class="text-primary">2</sup></i><span [textContent]="'(+'+ patient.patient.countryCode +') '+relativeMobile"></span>
                        </li>
                        <li *ngIf="!relativeMobile">
                            <i class="mdi mdi-phone-classic text-primary white-space-nowrap mr-1"><sup class="text-primary">2</sup></i><span [textContent]="'No mobile recorded'"></span>
                        </li>
                        <li>
                            <i class="mdi mdi-email-outline text-primary mr-1"></i><span class="dashboard-text-truncate" [textContent]="patient.patient.email || 'No email recorded'"></span>
                        </li>

                        <!--<li>
                <i (click)="onViewPatientEdit(commonid)" class="fe-edit text-primary mr-1"></i> <a class="cursor text-primary" (click)="onViewPatientEdit(commonid)">Edit</a>{{patient.patient.encryptedPatientId}}
            </li>-->
                    </ul>

                </div>
                <div class="row" *ngIf="isSettingHealthCard && routingValue==='bookApp'">
                    <div class="col-12">
                        <div class="card-header">Health card</div>
                        <!----><!----><!---->
                        <div class="table-responsive ng-star-inserted">
                            <table class="table table-bordered table-sm">
                                <tr>
                                    <th class="small">S.No</th>
                                    <th class="small">CardNo</th>
                                </tr><!---->
                                <tr style="cursor:pointer;"  *ngFor="let item of validCardDetails; let i = index" (click)="onSelectCard(item)" 
                                             [ngClass]="(item.isSelected == true) ?'bg-soft-blue':  'bg-soft-warning'"
                                            >
                                    <td class="small">{{i+1}}</td>

                                    <td>
                                        <div class="media-body" >
                                            <h5 class="mb-0 mt-0 font-weight-normal text-uppercase"
                                                [textContent]="item.cardNumber"></h5>
                                            <span class="d-block font-13">
                                                <span [textContent]="item.validTill | date:'dd/MM/yyyy'"></span>
                                            </span>
                                        </div>
                                        <!--<span [textContent]="item.cardNumber"></span>-->
                                        <!--<h6><b>{{item.cardNumber}}</b></h6>

                            <span [textContent]="item.validTill | date:'dd/MM/yyyy'"></span>-->
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
                <!--<small class="d-block font-13 mt-1x"></small>
    <h6 class="mb-0">
        <a href="javascript:;" class="text-dark">
            <span></span>
            <span></span>
        </a>
    </h6>
    <h6 class="mb-0">
        <a href="javascript:;" class="text-dark">
            <span></span>
            <span></span>
        </a>
    </h6>
    <h6 class="mt-2 mb-0 text-muted"></h6>
    <div class="mb-2">
        <span></span>
        <span></span>
    </div>-->
            </div>
        </ng-container>
    </div>
</div>
